import axios from "axios";
import React, { useEffect, useState } from "react";
import { createContext } from "react";
import { getIntentDetails, gateInOut } from "../../../apis/Api";
import { calculateDistance } from "../../../utils/service";
import ContentData from "../../../constants/contentFile.json";
import RouteConstant from "../../../constants/routesContent.json";
import { useNavigate, useLocation } from "react-router-dom";
import { getCookie } from "../../../utils/service";
import moment from "moment";
export const GateOutContext = createContext({});
export const GateOutContextProvider = ({ children }) => {
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  const [captureDate, setCaptureDate] = useState(null);
  const [captureTime, setCaptureTime] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [driverMobile, setDriverMobile] = useState("");
  const [intentDetails, setIntentDetails] = useState("");
  const [shareId, setShareId] = useState("")
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [imageErrorMsg, setImageErrorMsg] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [popUpMessages, setPopUpMessages] = useState("");
  const [vendorCode, setVendorCode] = useState("");
  const [plantLocation, setPlanLocation] = useState();
 const [ tokenShared, setTokenShared] = useState("");
  const [apiStatus, setApiStatus] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lon: longitude });
        },
        (error) => {
          console.error('Error fetching location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, []);

  const showIntentData = async(shareToken)=>{
    try {
      const getIntentData = await getIntentDetails(shareToken);
  
      setDriverMobile(getIntentData.data.intentInfo?.supplier_mobile);
      setIntentDetails(getIntentData?.data?.intentInfo)
      setShareId(getIntentData?.data?.vendorInfo?.share_id)
      setPlanLocation(getIntentData?.data?.vendorInfo)
      setVendorCode(getIntentData?.data?.vendorInfo?.vendor_code)
      setVehicleNumber(getIntentData?.data?.vendorInfo?.vehicle_no);
      
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error.response.data.statusMessage;
      } else {
        // setAlertMessage(loginContent.somethingWrong);
        // setShowAlert(true);
      }
    }
  }
  const details = [{ heading: "Freight Order No", data: intentDetails.sap_id }];

  const stationLocation = { lat: plantLocation?.vendor_latitude, lon: plantLocation?.vendor_longitude
  };
  useEffect(() => {
    // // Use dummy data instead of fetching real location
    // const dummyLocationWithinRadius = { lat: 12.9715, lon: 77.5945 }; // Within 250 meters
    // const dummyLocationOutsideRadius = { lat: 12.97, lon: 77.59 }; // Outside 250 meters
    // setCurrentLocation(dummyLocationOutsideRadius);
 
  
 const shareToken = getCookie('Share-Token');
  setTokenShared(shareToken)
    showIntentData(shareToken);
  }, []);

  useEffect(() => {
    // Check if the current location is within 250 meters of the station location
    if (currentLocation) {
      const distance = calculateDistance(
        currentLocation.lat,
        currentLocation.lon,
        stationLocation.lat,
        stationLocation.lon
      );
      setIsButtonEnabled(true);
      // if (distance <= 250) {
      //   setIsButtonEnabled(true);
      // } else {
      //   setIsButtonEnabled(false);
      // }
    }
  }, [currentLocation]);

  const BASE_URL = "http://vgeccdev.vguard.in:8001";

  const Axioscall = axios.create({
    baseURL: BASE_URL,
  });

  const gateOutApi = (payload) => {
    return Axioscall.post("/zgate_api/ZGATE", payload, {
      headers: {
        "content-type": "application/json",
      },
    });
  };



  const submitGateOutData = async () => {
  
    const gateOutDetails = {
      freight_order_no: intentDetails.sap_id,
      Vehicle_No: vehicleNumber,
      Gate_Out_at_Source_date:  moment(captureDate).format("YYYY-MM-DD"),
      Gate_Out_at_Source_time: captureTime,
      Driver_Mobile_No: driverMobile,
      vendor_code: vendorCode,
      Indicator_Out: "X", //Gate Out indicator
      Pickup: "",
      Dropoff: "",
      share_id: shareId,
      latitude: currentLocation?.lat,
      longitude: currentLocation?.lon
    };

    let hasError = false;

    // if (!vehicleNumber.trim()) {
    //   setErrorMsg(ContentData.gateInOutPage.enterField);
    //   hasError = true;
    // } else {
    //   setErrorMsg("");
    // }

    if (!captureDate || !captureTime) {
      setImageErrorMsg(ContentData.gateInOutPage.takePic);
      hasError = true;
    } else {
      setImageErrorMsg(null);
    }

    if (hasError) {
      return;
    }
   setApiStatus("fetching");
    try {
      const response = await gateInOut(gateOutDetails);
      if (response?.data?.statusCode == 200) {
        const successMessage = response?.data?.statusMessage
        setSuccessAlert(true)
        setPopUpMessages(successMessage)
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400 || error?.response?.data?.statusCode === 401 || error?.response?.data?.statusCode === 422) {
        const errorMessage = error.response.data.statusMessage;
        setErrorAlert(true);
        setPopUpMessages(errorMessage)
    }
  }
  setApiStatus("completed");
  };

  const handleCapturedImage = (image) => {
    setCapturedImage(image);

    const now = new Date();
    setCaptureDate(now.toLocaleDateString()); // Format: MM/DD/YYYY
    setCaptureTime(now.toLocaleTimeString()); // Format: HH:MM:SS AM/PM
  };

  // const onChangeVehicleNumber = (value) => {
  //   const capitalizedValue = value.toUpperCase();
  //   setErrorMsg("");
  //   setVehicleNumber(capitalizedValue);
  // };

  useEffect(() => {
    if (location.pathname !== RouteConstant.GATE_OUT) return;
    window.history.pushState(null, null, window.location.href);
  
    const handlePopState = () => {
      navigate(1); // Block back
    };
  
    window.addEventListener("popstate", handlePopState);
  
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname]);

  const providerValue = {
    vehicleNumber,
    errorMsg,
    // onChangeVehicleNumber,
    capturedImage,
    submitGateOutData,
    handleCapturedImage,
    details,
    isButtonEnabled,
    imageErrorMsg,
    successAlert,
    setSuccessAlert,
    popUpMessages,
    errorAlert,
    setErrorAlert,
    apiStatus,
  };

  return (
    <GateOutContext.Provider value={providerValue}>
      {children}
    </GateOutContext.Provider>
  );
};
